import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';
import { TAccountProviderUser, adaptAccountProviderUserFromResponse } from 'src/store';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_PROVIDER_USER } from '../../backend-paths';


export const accountProviderUserDeleteApi = createAsyncThunk(
	`DELETE/${BACKEND_ACCOUNT_PROVIDER_USER}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ACCOUNT_PROVIDER_USER}/${payload}`;

		return HttpService.delete(path).then(result => {
			return adaptAccountProviderUserFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TAccountProviderUser> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountProviderUserDeleteSlice = createSlice({
	name: 'accountProviderUserDeleteSlice',
	initialState,
	reducers: {
		clearAccountProviderUserDelete(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountProviderUserDeleteApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountProviderUserDeleteApi.fulfilled.type]: (state, action: PayloadAction<TAccountProviderUser>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountProviderUserDeleteApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountProviderUserDeleteSelector = () => useAppSelector(state => state[accountProviderUserDeleteSlice.name]);

export const { clearAccountProviderUserDelete } = accountProviderUserDeleteSlice.actions;
